"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Throttle = void 0;
var SuperAgentThrottle = require("superagent-throttle/dist/browser");
/**
 * Create a Throttle class and assign it to each of the API clients to restrict the number of requests
 * that can be made per second, thereby preventing TooManyRequests errors from being returned by the API's
 * rate limiting defenses.
 */
var Throttle = /** @class */ (function () {
    function Throttle(requestsPerSecond, concurrency) {
        this.throttles = [];
        this.createExtendedSuperAgentThrottle = function (requestsPerSecond, concurrency, methods) {
            var throttle = new SuperAgentThrottle({
                active: true,
                rate: requestsPerSecond || 10,
                ratePer: 1000,
                concurrent: concurrency || 2, // how many requests can be sent concurrently
            });
            throttle.methods = (methods || [])
                .filter(function (method) { return !!method; }) // ensure its a valid string (not null, undefined, or empty string)
                .map(function (x) { return x.toUpperCase(); });
            return throttle;
        };
        if (Array.isArray(requestsPerSecond)) {
            var opts = requestsPerSecond;
            for (var _i = 0, opts_1 = opts; _i < opts_1.length; _i++) {
                var opt = opts_1[_i];
                this.throttles.push(this.createExtendedSuperAgentThrottle(opt.requestsPerSecond, opt.concurrency, opt.methods));
            }
        }
        else {
            this.throttles.push(this.createExtendedSuperAgentThrottle(requestsPerSecond, concurrency));
        }
    }
    Throttle.prototype.apply = function (method, request) {
        var _method = (method || '').toUpperCase();
        var throttle;
        var index = this.throttles.findIndex(function (x) { return x.methods.findIndex(function (method) { return method === _method; }) >= 0; });
        if (index === -1) {
            index = this.throttles.findIndex(function (x) { return !x.methods.length; });
        }
        if (index >= 0) {
            throttle = this.throttles[index];
            request.use(throttle.plugin());
        }
    };
    return Throttle;
}());
exports.Throttle = Throttle;
var ExtendedSuperAgentThrottle = /** @class */ (function (_super) {
    __extends(ExtendedSuperAgentThrottle, _super);
    function ExtendedSuperAgentThrottle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ExtendedSuperAgentThrottle;
}(SuperAgentThrottle));
